import { NsContent } from '@britishgasenergy/react-nucleus/dist';

import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { TariffSelection } from 'components/direct-sales/tariff-information/components/TariffSelection';
import { TariffDetailsCard } from 'components/direct-sales/tariff-information/components/TariffDetailsCard';
import { AdditionalInformation } from 'components/direct-sales/tariff-information/components/AdditionalInformation';
import { ImportantInformation } from 'components/direct-sales/tariff-information/components/ImportantInformation';
import { useTariffInfo } from './hooks/useTariffInfo';
import { TariffInput } from './components/TariffInput';

export const testId = 'tariffInformationTestId';

const { VITE_BG_CLASIC_URL } = process.env;

export const TariffInformation = () => {
  const {
    isGasOnly,
    currentTariffId,
    tariffDetails,
    showTariffDetails,
    fuel,
    postcode,
    paymentMethod,
    shouldRenderTariffSelection
  } = useTariffInfo();

  return (
    <>
      <NsPanel testId={testId}>
        <NsContent>
          <NsTitle title="Tariff information" />
          <p className="p-normal">
            Get the list of our current and previous electricity and gas
            tariffs, where you can see unit rates, dates and standing charges.
            Just so you know, some tariffs may no longer be available. So if
            you’re looking to switch to one of our available tariffs you can{' '}
            <NsAnchor target={null} rel={null} href={VITE_BG_CLASIC_URL}>
              get a quote
            </NsAnchor>
            .
          </p>
        </NsContent>
        <TariffInput />
        {shouldRenderTariffSelection && (
          <TariffSelection
            isGasOnly={isGasOnly}
            fuel={fuel}
            postcode={postcode}
            paymentMethod={paymentMethod}
          />
        )}
        {showTariffDetails && (
          <>
            <TariffDetailsCard
              tariffDetails={tariffDetails}
              tariffId={currentTariffId}
            />
            <ImportantInformation
              termsAndConditions={tariffDetails.common.termsAndConditions}
            />
          </>
        )}
      </NsPanel>
      {showTariffDetails && <AdditionalInformation />}
    </>
  );
};

export default TariffInformation;
